





























































































































import IssueDetail from './scripts';
export default IssueDetail;
